import {getLogoData} from "./data/logo";
import {onEscPressPopupHandler} from "./on-esc-press-popup-handler";
import {renderFooterLight} from "./render-footer-light";
import {renderHeaderLight} from "./render-header-light";

window.userSessionData = null;
window.groupData = null;


export const initPageLight = (authCb) => {
  const logoData = getLogoData(shopInfoData);

  renderHeaderLight(shopInfoData, logoData, catalogList, authCb);
  renderFooterLight();

  const closePopupButtons = document.querySelectorAll(`.popup__closeButton`);

  Array.from(closePopupButtons).forEach((btn) => {
    btn.addEventListener(`click`, () => {
      const popup = btn.parentElement.parentElement;
      popup.classList.remove(`popup`, `popup--show`);
      document.removeEventListener(`keydown`, onEscPressPopupHandler);
      document.querySelector(`body`).classList.remove(`overflowHidden`);
    });
  });

  const closeModalButton = document.querySelectorAll(`.modal__closeButton`);

  Array.from(closeModalButton).forEach((button) => {
    button.addEventListener(`click`, () => {
      const modal = button.parentElement.parentElement;
      modal.classList.remove(`modal--show`);
      document.removeEventListener(`keydown`, onEscPressModalHandler);
    });
  });

  const overlayModalButton = document.querySelectorAll(`.modal__overlay`);

  Array.from(overlayModalButton).forEach((overlay) => {
    overlay.addEventListener(`click`, () => {
      const modal = overlay.parentElement;
      modal.classList.remove(`modal--show`);
      document.removeEventListener(`keydown`, onEscPressModalHandler);
    });
  });

  const onEscPressModalHandler = (evt) => {
    if (evt.key === `Escape`) {
      const modalElements = document.querySelectorAll(`.modal--show`);
      modalElements.forEach((elem) => {
        elem.classList.remove(`modal--show`);
        document.removeEventListener(`keydown`, onEscPressModalHandler);
      });
    }
  };
};
